var React = require('react');

function Gif (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(2 2)"},[React.createElement("text",{"fill":"currentColor","fontFamily":"ArialRoundedMTBold, Arial Rounded MT Bold","fontSize":"11","key":0},React.createElement("tspan",{"x":"3.101","y":"11"},"GIF")),React.createElement("rect",{"width":"25","height":"14","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","rx":"2","key":1})]));
}

Gif.defaultProps = {"width":"29","height":"18","viewBox":"0 0 29 18"};

module.exports = Gif;

Gif.default = Gif;
